import getConfig from "./config";
import {convertToString, isObject} from "./helpers";

const config = getConfig();

/**
 *
 * @param {{}} data
 * @returns {Promise<Response|null>}
 */
const ajax = async (data = {}) => {
    if (!config.ajaxUrl) {
        console.error("config.ajaxUrl is undefined in config.js");
        return null;
    }

    if (!isObject(data)) {
        console.error(
            "Supplied data parameter to function ajax() must be an object (not an Array or Function)",
            data,
        );
        return null;
    }

    let response = null;
    try {
        const params = new URLSearchParams();

        for (const [key, value] of Object.entries(data)) {
            parseDataEntry(key, value, params);
        }

        response = fetch(config.ajaxUrl, {
            method: "POST",
            headers: new Headers({
                Accept: "application/json",
                "Content-Type":
                    "application/x-www-form-urlencoded; charset=UTF-8",
            }),
            body: params,
        });
    } catch (err) {
        console.error(err);
    }

    return response;
};

const getResponseData = async (response) => {
    response = response instanceof Promise ? await response : response;

    if (!(response instanceof Response)) {
        console.error(
            "Supplied response parameter to function getResponseData() is not an instance of Response",
            response,
        );
        return null;
    }

    if (!response.ok) {
        console.error(response.statusText);
        return null;
    }

    return await response.json();
};

const parseDataEntry = (key, value, params) => {
    if (Array.isArray(value)) {
        for (const subval of value) {
            parseDataEntry(`${key}[]`, subval, params);
        }
    } else if (isObject(value)) {
        for (const [subkey, subval] of Object.entries(value)) {
            parseDataEntry(`${key}[${subkey}]`, subval, params);
        }
    } else {
        params.append(key, convertToString(value));
    }
};

export {ajax, getResponseData};
